import { Link } from "react-router-dom";
import { useState } from "react";
import { MapPin, Calendar, Users, ArrowRight } from "lucide-react";
import MspShell from "../../components/msp/MspShell";

const POPULAR = [
  { name: "Japan",    img: "https://images.unsplash.com/photo-1526481280693-3bfa7568e0f3?auto=format&fit=crop&w=500&q=70" },
  { name: "Italy",    img: "https://images.unsplash.com/photo-1552832230-c0197dd311b5?auto=format&fit=crop&w=500&q=70" },
  { name: "France",   img: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&w=500&q=70" },
  { name: "Thailand", img: "https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?auto=format&fit=crop&w=500&q=70" },
];

export default function MspPlan() {
  const [where, setWhere] = useState("");
  return (
    <MspShell title="Plan Your Next Adventure" testid="msp-plan">
      <p className="text-sm text-slate-600 -mt-2">Let our tools help you every step of the way.</p>

      <div className="bg-white rounded-3xl border border-slate-200 p-5 space-y-4 shadow-sm">
        <div>
          <label className="text-xs font-700 text-slate-500 uppercase tracking-wider">Where do you want to go?</label>
          <div className="mt-2 flex items-center gap-2 border-b border-slate-200 py-2">
            <MapPin className="w-4 h-4 text-blue-600" />
            <input value={where} onChange={(e) => setWhere(e.target.value)} data-testid="msp-plan-where"
              className="flex-1 bg-transparent outline-none text-slate-800 placeholder:text-slate-400"
              placeholder="Search destination or country" />
          </div>
        </div>
        <div>
          <label className="text-xs font-700 text-slate-500 uppercase tracking-wider">Travel Dates</label>
          <div className="mt-2 flex items-center gap-2 border-b border-slate-200 py-2">
            <Calendar className="w-4 h-4 text-blue-600" />
            <input type="text" data-testid="msp-plan-dates"
              className="flex-1 bg-transparent outline-none text-slate-800 placeholder:text-slate-400"
              placeholder="Mar 27, 2027 → Apr 5, 2027" />
          </div>
        </div>
        <div>
          <label className="text-xs font-700 text-slate-500 uppercase tracking-wider">Travelers</label>
          <div className="mt-2 flex items-center gap-2 border-b border-slate-200 py-2">
            <Users className="w-4 h-4 text-blue-600" />
            <input type="text" data-testid="msp-plan-travelers"
              className="flex-1 bg-transparent outline-none text-slate-800 placeholder:text-slate-400"
              placeholder="2 Adults · 0 Children" />
          </div>
        </div>
        <Link to="/msp/hotels" data-testid="msp-plan-submit"
          className="w-full inline-flex items-center justify-center gap-2 rounded-2xl bg-blue-600 text-white py-3.5 font-700 hover:brightness-110">
          Plan My Trip <ArrowRight className="w-4 h-4" />
        </Link>
      </div>

      <div>
        <div className="flex items-center justify-between mb-3">
          <div className="font-serif font-800 text-xl text-blue-900">Popular Destinations</div>
          <Link to="/destinations" className="text-blue-600 text-sm font-700 hover:underline">See all</Link>
        </div>
        <div className="grid grid-cols-4 gap-3">
          {POPULAR.map((p) => (
            <Link key={p.name} to={`/msp/hotels?loc=${encodeURIComponent(p.name)}`} data-testid={`msp-popular-${p.name.toLowerCase()}`}
              className="text-center">
              <div className="w-full aspect-square rounded-2xl overflow-hidden border border-slate-200 shadow-sm hover:shadow-md transition">
                <img src={p.img} alt={p.name} loading="lazy" className="w-full h-full object-cover" />
              </div>
              <div className="mt-1.5 text-xs font-700 text-slate-700">{p.name}</div>
            </Link>
          ))}
        </div>
      </div>
    </MspShell>
  );
}
